var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightWithLine(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8997 5.39966C13.6068 5.69256 13.6068 6.16743 13.8997 6.46032L19.4393 12L13.8997 17.5397C13.6068 17.8326 13.6068 18.3074 13.8997 18.6003C14.1926 18.8932 14.6674 18.8932 14.9603 18.6003L21.0303 12.5303C21.171 12.3897 21.25 12.1989 21.25 12C21.25 11.8011 21.171 11.6103 21.0303 11.4697L14.9603 5.39966C14.6674 5.10677 14.1926 5.10677 13.8997 5.39966Z",
    fill: "#1F2328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.08 12C21.08 11.5858 20.7442 11.25 20.33 11.25H3.50002C3.0858 11.25 2.75002 11.5858 2.75002 12C2.75002 12.4142 3.0858 12.75 3.50002 12.75H20.33C20.7442 12.75 21.08 12.4142 21.08 12Z",
    fill: "#1F2328"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWithLine);
export default __webpack_public_path__ + "static/media/arrow-right-with-line.7d9f31c2d5da951e24fab50e6db6f78a.svg";
export { ForwardRef as ReactComponent };